import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../provider/providerManager';
import {showAppLoader, hideAppLoader} from "app/Components/Shared/Loader/LoaderSlice";

export const init = createAsyncThunk('Coupons/GetCouponHistory', async (subscriberNumber, thunkAPI) => {
  try {
    thunkAPI.dispatch(showAppLoader());
    const coupons = await ProviderManager.getProviderData("getCouponHistory", []);
    return coupons?.Body?.coupons;
  } catch (error) {
    return [];
  } finally {
    thunkAPI.dispatch(hideAppLoader());
  }
});

const couponHistorySlice = createSlice({
  name: 'couponHistory',
  initialState: {
    isLoading: false,
    coupons: [],
  },
  reducers: {

  },
  extraReducers: {
    [init.pending]: (state) => {
      state.isLoading = true;
    },
    [init.fulfilled]: (state, action) => {
      state.coupons =  action.payload;
      state.isLoading = false;
    },
    [init.rejected]: (state) => {
      state.coupons = [];
    },
  }
});

export const {

} = couponHistorySlice.actions;

export default couponHistorySlice.reducer;
